import { render, staticRenderFns } from "./ReserveCar.vue?vue&type=template&id=b2c931a0&scoped=true&"
import script from "./ReserveCar.vue?vue&type=script&lang=js&"
export * from "./ReserveCar.vue?vue&type=script&lang=js&"
import style0 from "./ReserveCar.vue?vue&type=style&index=0&id=b2c931a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c931a0",
  null
  
)

export default component.exports